export default function storyblokLoader({
  src,
  width,
  quality,
}: {
  src: string
  width: number
  quality?: number
}): string {
  const q = quality ?? 65

  // Return as-is for non-Storyblok URLs, SVGs, or already-transformed URLs
  if (!src.includes('a.storyblok.com') || src.endsWith('.svg') || src.includes('/m/')) {
    return src
  }

  return `${src}/m/${width}x0/filters:format(webp):quality(${q})`
}
